/* src/app/features/player/components/player-controls/components/player-controls-seek-preview/player-controls-seek-preview.scss */
:host {
  position: absolute;
  bottom: 60px;
  transform: translateX(-50%);
  z-index: 10;
}
.seek-preview-container {
  overflow: hidden;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.7);
}
.seek-preview-container .seek-preview {
  width: 240px;
  height: 135px;
  padding: 2px;
  padding-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  background:
    linear-gradient(
      to bottom,
      var(--highlight_primary),
      var(--background_secondary));
}
.seek-preview-container img {
  display: block;
  object-fit: cover;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  width: 100%;
  height: 100%;
}
.seek-preview-container .seek-preview-current-time {
  width: 100%;
  height: 39px;
  line-height: 19px;
  background-color: var(--background_secondary);
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=player-controls-seek-preview.css.map */
